import React from 'react'
import { HeaderWidgetContainer } from '../../components/Header/header-widget/HeaderWidgetContainer'
import styles from '../Header/header-widget/index.module.scss'
import { IconOnCircle } from '../../components/icon-on-circle'
import { Link } from '@ztechapps/webui.util'

export const ActionWidget = ({ onClick, icon }) => {
  return (
    <HeaderWidgetContainer>
      <Link className={styles.widgetHeader} onClick={onClick}>
        <IconOnCircle icon={icon} className="border"></IconOnCircle>
      </Link>
    </HeaderWidgetContainer>
  )
}
